export default "__VITE_ASSET__TOMvfpNX__"